// Single source of truth for the "open files" that make up the page.
// Drives the sidebar explorer, the tab bar and the status bar language mode.
export const navFiles = [
  { id: "home", file: "README.md", ext: "md", language: "Markdown" },
  { id: "about", file: "about.js", ext: "js", language: "JavaScript" },
  { id: "background", file: "background.js", ext: "js", language: "JavaScript" },
  { id: "experience", file: "experience.log", ext: "log", language: "Log" },
  { id: "projects", file: "projects.json", ext: "json", language: "JSON" },
  { id: "contacts", file: "contact.sh", ext: "sh", language: "Shell Script" },
];
